import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Popover } from '@mui/material';
import AsyncJobs from './AsyncJobs';
import { closeJobs } from '../../redux/actions/asyncJobActions';
import * as asyncJobActions from '../../redux/actions/asyncJobActions';

const AsyncJobsDialog = (popoverProps) => {
  const { open, jobs, intervals } = useSelector((state) => state.AsyncJob);
  const dispatch = useDispatch();

  useEffect(() => {
    const asyncEffect = async () => {
      if (open && !intervals.length) {
        dispatch(
          asyncJobActions.startCheckingJobs(dispatch, {
            startCheckTime: new Date(),
          })
        );
      } else if (!open) {
        dispatch(asyncJobActions.stopCheckingJobs());
      }
    };
    asyncEffect().catch((err) => console.error(err));
  }, [open]);

  return (
    <Popover
      id="jobs-popover"
      open={!!popoverProps.anchorEl && open}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      onClose={() => dispatch(closeJobs())}
      {...popoverProps}
    >
      <AsyncJobs jobs={jobs} />
    </Popover>
  );
};

export default AsyncJobsDialog;
